import reducers from './reducers'

export { default as articlesTypes } from './types'
export { default as articlesActions } from './actions'
export { default as articlesSelectors } from './selectors'
export { default as articlesEpics } from './epics'

export default reducers
